import type { ReactNode } from 'react';

import { Breadcrumb, Container, Flex } from '@grupoboticario/flora-react';

import Styles from './PageInfo.styles';

import type { NavigationProps } from './PageInfo.d';

export const PageInfo = ({
  children,
  breadcrumbs = [],
}: {
  children?: ReactNode;
  breadcrumbs?: NavigationProps[];
}) => {
  const homePath = process.env.HOME_PATH || '/departamentos';

  const breadCrumbPaths = breadcrumbs;

  return (
    <Styles.Wrapper>
      <Container size='large'>
        <Flex align='start' direction='column' gapY='$4'>
          <Breadcrumb
            navigation={[
              {
                text: 'Início',
                url: homePath,
              },
              ...breadCrumbPaths,
            ]}
          />
          {children}
        </Flex>
      </Container>
    </Styles.Wrapper>
  );
};
